import { AxiosInstance } from "axios";

import { ICatchIssueUseCase } from "../catch-issue.usecase";
import { IBookmarkContent } from "@mais-retorno-front/models/content-bookmark.model";

interface IHandleResponse {
  bookmarksIds: string[];
  error?: boolean;
}

type GetAllBookmarkContentUseCaseProps = {
  handle: () => Promise<IHandleResponse>;
}

export class GetAllBookmarkContentUseCase implements GetAllBookmarkContentUseCaseProps {
  constructor (
    private readonly url: string,
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ){}

  async handle(): Promise<IHandleResponse> {
    try {
      const { data } = await this.http.get<IBookmarkContent[]>(this.url);
      
      const bookmarksIds: string[] = data.map((item) => (item.content_slug));

      return {
        bookmarksIds
      };
    } catch (error) {
        this.catchIssueUseCase.handle({
          error,
          errorName: 'GetAllBookmarkContentUseCase',
        });

        return {
          bookmarksIds: [],
          error: true
        };
      }       
    }
 }